import { computed } from 'vue';

type CaptionItemProps = {
    caption?: string;
};

export const CaptionItemSeoSetup = (props: CaptionItemProps) => {
    const hashtagLinksText = computed(() => {
        if ((props.caption || '').length === 0) {
            return '';
        }

        const hashtagRegex = /#((?:[^#])*)/g;
        const replacedStr = (props.caption || '').replace(/\([^()]*\)/g, '').replace(hashtagRegex, match => {
            const linkText = match.replace(/ /g, '-');
            return `<a class='hast-tag' style="color: rgba(0, 65, 130, 1);" href="/discover/${linkText}">${match}</a>`;
        });

        return replacedStr.replace(/href="(.+?)#(.+?)"/g, 'href="$1$2"');
    });

    return {
        hashtagLinksText,
    };
};
